import { render } from "./detail-pay.vue?vue&type=template&id=bc5a6630&ts=true"
import script from "./detail-pay.vue?vue&type=script&lang=ts"
export * from "./detail-pay.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__